<div class="job-history">
  <div class="job-history__toolbar">
    <app-input
      class="job-history__search"
      type="search"
      [placeholder]="'GLOBAL.RECHERCHER' | translate"
      [clearable]="true"
      [ngModel]="searchText()"
      (ngModelChange)="onSearchChange($event)"
      data-attr="blast-history-search">
      <img slot="icon-left" src="assets/icon/new_icon/search.svg" alt="" />
    </app-input>

    <div class="job-history__actions">
      <app-button
        variant="secondary"
        color="amarante"
        size="medium"
        [label]="'BLAST_HISTORY.MULTI_DOWNLOAD' | translate"
        [addIconLeft]="true"
        [state]="downloadableRows().length > 0 ? 'default' : 'disabled'"
        data-attr="blast-history-multi-download"
        (clicked)="downloadAll()">
        <img slot="icon-left" src="assets/icon/download.svg" alt="" />
      </app-button>
      <app-button
        variant="tertiary"
        color="amarante"
        size="medium"
        [addIconLeft]="true"
        [addLabel]="false"
        [attr.title]="'BLAST_HISTORY.REFRESH' | translate"
        data-attr="blast-history-refresh"
        (clicked)="refresh()">
        <img slot="icon-left" src="assets/icon/new_icon/restore.svg" alt="" />
      </app-button>
    </div>
  </div>

  <div class="job-history__table-wrapper">
    <table class="job-history__table">
      <thead>
        <tr>
          @for (column of columns; track column.key) {
            <th>
              <button
                type="button"
                class="sort-header"
                [class.sort-header--active]="sortKey() === column.key"
                (click)="toggleSort(column.key)">
                {{ column.label | translate }}
                <img
                  class="sort-header__icon"
                  [class.sort-header__icon--asc]="sortKey() === column.key && sortDirection() === 'asc'"
                  src="assets/icon/new_icon/arrow_full_down.svg"
                  alt="" />
              </button>
            </th>
          }
          <th class="job-history__action-col"></th>
        </tr>
      </thead>
      <tbody>
        @if (loading()) {
          <tr>
            <td class="job-history__message" colspan="5">{{ 'GLOBAL.CHARGEMENT' | translate }}</td>
          </tr>
        } @else {
          @for (row of pagedRows(); track row.job.jobId) {
            <tr
              [class.row--reenabled]="row.reenabledHoles"
              [attr.title]="row.reenabledHoles ? ('BLAST_HISTORY.REENABLED_HOLES' | translate) : null">
              <td>
                <span class="source" [attr.title]="row.filePath || null">
                  {{ row.source }}
                  @if (row.filePath) {
                    <img class="source__icon" src="assets/icon/files.svg" alt="" />
                  }
                </span>
              </td>
              <td>
                @if (row.firstName || row.lastName) {
                  <span class="user">
                    <span>{{ row.firstName }}</span>
                    <span>{{ row.lastName }}</span>
                  </span>
                } @else {
                  {{ row.user }}
                }
              </td>
              <td>{{ row.date }}</td>
              <td>
                <span class="status-cell">
                  <span
                    class="status"
                    [class]="'status ' + row.status"
                    [class.status--clickable]="row.canDownload"
                    [attr.title]="row.status === 'status-partial' ? row.errors : (statusLabelKeys[row.status] | translate)"
                    (click)="downloadFile(row)">
                    @switch (row.status) {
                      @case ('status-success') {
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" />
                          <path d="M8 12.5l2.5 2.5L16 9.5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                      }
                      @case ('status-partial') {
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <path d="M12 3.5L21.5 20h-19L12 3.5z" fill="none" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                          <path d="M12 10v4.5M12 17.2v.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                      }
                      @case ('status-error') {
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" />
                          <path d="M9 9l6 6M15 9l-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                      }
                      @default {
                        <svg viewBox="0 0 24 24" aria-hidden="true">
                          <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" />
                          <path d="M9.5 9.5a2.5 2.5 0 1 1 3.5 2.3c-.6.3-1 .8-1 1.5v.4M12 16.8v.3" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                        </svg>
                      }
                    }
                  </span>
                  @if (row.reenabledHoles) {
                    <svg class="status-cell__info" viewBox="0 0 24 24" aria-hidden="true">
                      <circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="2" />
                      <path d="M12 11v5.5M12 7.7v.3" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                    </svg>
                  }
                </span>
              </td>
              <td class="job-history__action-col">
                @if (row.canDownload) {
                  <app-button
                    variant="tertiary"
                    color="amarante"
                    size="small"
                    [addIconLeft]="true"
                    [addLabel]="false"
                    [attr.title]="'BLAST_HISTORY.DOWNLOAD_FILE' | translate"
                    (clicked)="downloadFile(row)">
                    <img slot="icon-left" src="assets/icon/download.svg" alt="" />
                  </app-button>
                }
              </td>
            </tr>
          } @empty {
            <tr>
              <td class="job-history__message" colspan="5">{{ 'BLAST_HISTORY.NO_DATA' | translate }}</td>
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  <div class="job-history__pager">
    <span class="job-history__page">{{ 'BLAST_HISTORY.PAGE' | translate: { current: currentPage(), total: pageCount() } }}</span>
    <button
      type="button"
      class="pager-button"
      [disabled]="currentPage() === 1"
      [attr.aria-label]="'previous page'"
      (click)="previousPage()">
      <img src="assets/icon/new_icon/arrow-left.svg" alt="" />
    </button>
    <button
      type="button"
      class="pager-button"
      [disabled]="currentPage() === pageCount()"
      [attr.aria-label]="'next page'"
      (click)="nextPage()">
      <img src="assets/icon/new_icon/arrow-right.svg" alt="" />
    </button>
  </div>
</div>
